import React, { forwardRef } from 'react';
import MaterialRadio from '@material-ui/core/Radio';

const Radio = forwardRef((props, ref) => {
    const attrs = { ref };

    return (
        <MaterialRadio
            disableRipple
            color="default"
            checkedIcon={<span className="NeptuneRadio-checkedIcon" />}
            icon={<span className="NeptuneRadio-icon" />}
            {...attrs}
            {...props}
        />
    );
});

Radio.displayName = 'NeptuneRadio';
Radio.propTypes = { ...MaterialRadio.propTypes };

export default Radio;
